// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const IdentityIdStorageKeys = {
    identityId: 'identityId',
};

export { IdentityIdStorageKeys };
//# sourceMappingURL=types.mjs.map
